module.exports = __webpack_public_path__ + "img/not-image.2d71584e.jpg";